export default __webpack_public_path__ + "static/media/node.fdd740f5.jpg";